import { GenericParam } from '../common/interfaces/commons';

export const sortByName = (a: GenericParam, b: GenericParam) => a.name.localeCompare(b.name, 'en', { numeric: true });
export const sortByFirstName = (a: GenericParam, b: GenericParam) => a.firstName.localeCompare(b.firstName, 'en', { numeric: true });
export const sortTankStatus = (a: GenericParam, b: GenericParam) => a.status.localeCompare(b.status);